import { styled } from '@mui/material';

export const FlexW = styled('div')`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 742px;
  margin: 24px auto 0;
`;
